import React, { useEffect } from 'react';
import { Mail, Calendar, Clock, ArrowRight } from 'lucide-react';
import Header from '@/components/public/Header';
import Footer from '@/components/public/Footer';

const BRAND = '#00d68f';

const LinkedinContactPage = () => {
  useEffect(() => {
    document.title = 'Get in touch — StartEase AI';
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="linkedin-contact-page">
      <Header />

      <section className="bg-slate-900 py-16">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3">Get in touch</h1>
          <p className="text-slate-300 max-w-xl mx-auto">
            For support questions or custom version enquiries.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="container-custom max-w-2xl">
          <div
            className="rounded-2xl p-8 border bg-white"
            style={{ borderColor: `${BRAND}55` }}
            data-testid="linkedin-contact-card"
          >
            <div className="flex items-start gap-4 mb-7">
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ background: `${BRAND}1a`, color: BRAND }}
              >
                <Mail className="w-6 h-6" />
              </div>
              <div>
                <p className="text-sm text-slate-500 mb-1">Email</p>
                <a
                  href="mailto:hi@starteaseai.com"
                  className="text-lg font-semibold text-slate-900 hover:underline"
                  data-testid="linkedin-contact-email"
                >
                  hi@starteaseai.com
                </a>
              </div>
            </div>

            <a
              href="https://calendly.com/starteaseai/strategy-call"
              target="_blank"
              rel="noreferrer"
              data-testid="linkedin-book-call-btn"
              className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md font-semibold text-slate-900 transition-colors"
              style={{ background: BRAND }}
            >
              <Calendar className="w-5 h-5" /> Book a call <ArrowRight className="w-4 h-4" />
            </a>

            <div className="mt-6 flex items-center gap-2 text-sm text-slate-600">
              <Clock className="w-4 h-4" style={{ color: BRAND }} />
              Response time: We respond within 24 hours.
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LinkedinContactPage;
